define('models/pages/trade/request/index',['require','underscore','chaplin','models/base/model','models/base/collection','models/pages/trade/request/sub'],function(require) {
    'use strict';

    var _ = require('underscore');
    var Chaplin = require('chaplin');
    var Model = require('models/base/model');
    var Collection = require('models/base/collection');
    var Sub = require('models/pages/trade/request/sub');

    var fakeId = 0;

    var RequestItem = Model.extend({
        idAttribute: 'fakeId',
        defaults: {
            fakeId: 0
        },
        urlPath: function() {
            return '/request-item/' + this.get('requestId');
        },
        parse: function(data) {
            data.fakeId = fakeId++;
            return data;
        }
    });

    var RequestItemsCollection = Collection.extend({
        model: RequestItem,
        initialize: function() {
            Collection.prototype.initialize.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
        }
    });


    function updateRequestProcessed(requests, processed) {
        // console.log('updateRequestProcessed');

        function doFilter(item) {
            return function(pitem) {
                return item.get('requestId') === pitem.get('requestId');
            };
        }

        function toJSON(item) {
            return item.toJSON();
        }

        var item;
        for (var i=0, li=requests.length; i<li; i++) {
            item = requests.at(i);
            item.set('processed', processed.filter(doFilter(item)).map(toJSON));
        }
    }

    function calcSum(requests) {
        var item, requestSum, confirmedSum;

        var group = requests.groupBy('requestId');

        requestSum = Object.keys(group).reduce(function(sum, key) {
            return sum + group[key][0].get('sum');
        }, 0);

        confirmedSum = requests.reduce(function(sum, item) {
            var processed = item.get('processed');
            return sum + ((processed.status === 'confirmed') ? processed.sum : 0);
        }, 0);

        // console.log('sum', requestSum, confirmedSum);

        return {
            requestSum: requestSum,
            confirmedSum: confirmedSum
        };
    }

    var RequestPageModel = Model.extend({
        urlPath: '/page/request',
        defaults: {
            requestSum: '0.00',
            confirmedSum: '0.00',

            currency: '',

            canDelete: false,

            filterStatus_requested: true,
            filterStatus_processing: true,
            filterStatus_declined: true,
            filterStatus_check: true,
            filterStatus_ok: true,
            filterStatus_confirmed: true,
            filterType_om: true,
            filterType_on: true,
            filterType_fo: true,
            filterType_so: true
        },
        constructor: function(data) {
            Model.apply(this, arguments);

            var _this = this;

            this.sub = new Sub({ tradeId: this.get('id') });

            var items = new RequestItemsCollection(data ? data.items : [], { parse: true });
            this.items = items;

            items.comparator = function(item){
                return [item.get('requestId'), item.get('processed').processedId].join('-');
            };
            // this.processed = new ProcessedItemsCollection(data ? data.processed : [], { parse: true });

            this.sub.on('change:fakeId', function() {
                var found, change = this.getAttributes();
                // console.log('sub change', change);

                if (this.get('type') === 'update') {
                    found = items.where({ 'requestId': change.requestId });

                    found.forEach(function(item) {
                        var processed = item.get('processed');
                        if (processed.processedId === change.processedId) {
                            item.set(change.item);
                        }
                    });

                }

                if (this.get('type') === 'create') {
                    found = items.where({ 'requestId': change.requestId });

                    if (found.length === 1 && found[0].get('processed').status === 'requested') {
                        found[0].set(change.item);
                    } else {
                        items.add(change.item, { silent: true });
                    }
                }

                if (this.get('type') === 'delete') {
                    found = items.where({ 'requestId': change.requestId });

                    if (found.length > 1) {

                        found.forEach(function(item) {
                            var processed = item.get('processed');
                            if (processed.processedId === change.processedId) {
                                item.destroy();
                            }
                        });

                    } else {
                        found[0].set(change.item);
                    }
                }

                items.sort({ silent: true });

                var idx, requestId;
                var group = items.groupBy('requestId');

                Object.keys(group).forEach(function(key) {

                    var items = group[key];

                    items.forEach(function(item, index) {
                        item.set({
                            index: index,
                            processedCount: items.length
                        });
                    });
                });

                // console.log('>', items);

                items.sort({ silent: false });

                _this.set(calcSum(_this.items));
            });

            // this.items.on('add remove reset', function() {
            //     console.log('CHANGED', 'requests');
            //     _this.set(calcSum(_this.items));
            //     // updateRequestProcessed(_this.requests, _this.processed);
            // });

            // this.processed.on('add remove reset', function() {
            //     console.log('CHANGED', 'processed');
            //     _this.set('requestSum', calcRequestSum(_this.requests));
            //     _this.set('confirmedSum', calcConfirmedSum(_this.processed));
            //     updateRequestProcessed(_this.requests, _this.processed);
            // });

            this.on('beforeLoad', function() {
                this.items.beginSync();
            });

            this.on('afterLoad', function() {
                this.items.finishSync();
            });
        },
        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);
            params.tradeId = this.get('id');
            return params;
        },
        parse: function(data) {
            console.log('data', data);


            // if (data.processed) {
            //     this.processed.reset(data.processed, { silent: true });
            // }

            if (data.items) {
                this.items.reset(data.items, { silent: true });
            }

            setTimeout(function() {
                this.items.trigger('reset');
            }.bind(this), 10);

            return data;
        }

    });

    return RequestPageModel;
});
